<script>
import { mapGetters, mapState } from "vuex"
export default {
  data() {
    return {
      trigger: false,
    }
  },
  computed: {
    ...mapState("SessionManager", ["warningCount"]),
    serviceURL() {
      return `${origin}/`
    },
    ...mapGetters("AuthService", [
      "showWarningMsg",
      "getWarningMsg",
      "getAccountExpired",
    ]),
  },
  watch: {
    warningCount() {
      this.trigger = true
    },
  },
  created() {
    this.$store.dispatch("SessionManager/checkSession")
  },
  methods: {
    onExtend() {
      this.$store.dispatch("SessionManager/extendSession")
      this.hide()
    },
    hide() {
      this.trigger = false
    },
  },
}
</script>

<template>
  <div>
    <!-- Login Modal -->
    <b-modal
      id="sessionModal"
      v-model="trigger"
      title="Session Expiring"
      hide-header
      hide-footer
      @hidden="hide"
    >
      <h4>Session Expiring</h4>
      <b-row>
        <b-col>
          Your session is going to expire shortly. Would you like to extend your session?
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button type="button" class="extendButton" squared @click="onExtend">Extend Session</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <a class="closeLink"><span @click="hide">Close</span></a>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<style>
#sessionModal {
  text-align: center;
}
#sessionModal .modal-body {
  background-color: #ebebeb;
  padding: 20px;
}
#sessionModal h4 {
  color: #414141;
  font-family: "Proxima Nova";
  font-weight: bold;
}
#sessionModal .row {
  padding-top: 5px;
  padding-bottom: 5px;
}
#sessionModal .extendButton {
  width: 220px;
  color: #e1e1e1;
}
#sessionModal a {
  color: #414141;
}
#sessionModal a.closeLink,
#sessionModal a.closeLink:link,
#sessionModal a.closeLink:visited {
  text-decoration: underline;
}
#sessionModal a.closeLink:hover,
#sessionModal a.closeLink:active {
  cursor: pointer;
}
</style>
